import React, {ReactElement, useContext} from 'react';
import {useIntl} from 'react-intl';

import DeviceContext, {Device} from '../../../RootProvider/DeviceContext';
import {Locale, useLocale} from '../../../RootProvider/LocaleContext';
import {Alignment, AccordionItemProps} from '../../../types';
import Accordion, {AccordionStartOpen} from '../../DesignSystem/Accordion/Accordion';
import LayoutSection, {LayoutBackground} from '../../DesignSystem/Layout/LayoutSection/LayoutSection';
import SectionTitleAndSubtitle from '../../DesignSystem/SectionTitleAndSubtitle/SectionTitleAndSubtitle';
import SectionContent from './SectionContent';
import {getFinanceByType, getFinanceBySituation, getHowToGuides} from './SectionLinks';

import './WantToKnowMore.scss';

function WantToKnowMore(): ReactElement {
  const locale = useLocale();
  const {formatMessage} = useIntl();
  const device = useContext(DeviceContext);
  const isMobile = device === Device.MOBILE;

  const items: AccordionItemProps[] = [
    {
      id: 'financeByType',
      label: formatMessage({id: 'homepage.wantToKnowMore.accordionSection.financeByType'}),
      children: <SectionContent links={getFinanceByType(formatMessage, locale)} />,
    },
  ];

  if ([Locale.uk].includes(locale)) {
    items.push(
      {
        id: 'financeBySituation',
        label: formatMessage({id: 'homepage.wantToKnowMore.accordionSection.financeBySituation'}),
        children: <SectionContent links={getFinanceBySituation(formatMessage)} />,
      },
      {
        id: 'howToGuides',
        label: formatMessage({id: 'homepage.wantToKnowMore.accordionSection.howToGuides'}),
        children: <SectionContent links={getHowToGuides(formatMessage)} />,
      }
    );
  }

  return (
    <LayoutSection type={LayoutBackground.WHITE} innerClassName="wantToKnowMore">
      <SectionTitleAndSubtitle
        alignment={isMobile ? Alignment.LEFT : Alignment.CENTER}
        text={formatMessage({id: 'homepage.wantToKnowMore.sectionTitleAndSubtitle.text'})}
        title={formatMessage({id: 'homepage.wantToKnowMore.sectionTitleAndSubtitle.title'})}
      />
      <Accordion className="wantToKnowMore__accordion" startOpen={AccordionStartOpen.FIRST} items={items} />
    </LayoutSection>
  );
}

export default WantToKnowMore;
